import LocalizationOff from './LocalizationOff';

export default LocalizationOff;
